export default __webpack_public_path__ + "static/media/flv4.6332ca59.jpeg";